<template>
	<div class="numpad-container">
		<div class="numpad-container-background">
			<div class="numpad-screen-container">
				<div class="numpad-screen">
					{{ currencyStore.readableCurrencyValue(numpadNumber) }}
				</div>
			</div>
			<div class="numpad-actions-container">
				<div class="numpad">
					<BottomNumberEditorNumpad no-actions ref="numpad" @change-number="v => numpadNumber = v" :startingNumber="0" />
				</div>
				<div class="numpad-actions">
					<div v-if="!loadingCta" class="numpad-action-container" :class="{disabled: numpadNumber === 0}" @click="clickAdd"><div class="numpad-action" v-html="svgStore.get('iconSend')"></div></div>
					<div class="loader-container" v-else><AppLoader /></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BottomNumberEditorNumpad from "@/console-new/components/ops/counter/BottomNumberEditorNumpad.vue";
import {useCurrencyStore, useLanguageStore, useSvgStore} from "@/shared/stores";
import {useCounterStore, useOrdersStore, useRoomsStore, useUserStore} from "@/console-new/stores";
import AppLoader from "@/shared/components/AppLoader.vue";

export default {
	setup() {
		const roomsStore = useRoomsStore();
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let svgStore = useSvgStore();
		let ordersStore = useOrdersStore();
		let counterStore = useCounterStore();
		const currencyStore = useCurrencyStore();
		return {languageStore, getString: languageStore.getString, userStore, currencyStore, svgStore, ordersStore, counterStore, roomsStore};
	},
	name: "PayBillNumpad",
	components: {AppLoader, BottomNumberEditorNumpad},
	emits: ['order-created'],
	props: {
		table: {
			type: [Object, null],
			required: true
		}
	},
	data() {
		return {
			numpadNumber: 0,
			loadingCta: false
		}
	},
	methods: {
		clickAdd() {
			if(this.loadingCta) return;
			if (this.numpadNumber > 0) {

				this.counterStore.selectedTable = this.table;
				this.counterStore.selectedMode = "qr";
				this.counterStore.deliveryCosts = 0;
				this.counterStore.takeawayCosts = 0;
				this.counterStore.coverNum = 0;
				this.counterStore.coverCharge = 0;
				this.counterStore.addCartFakeItem(this.numpadNumber);

				this.loadingCta = true;
				this.counterStore.createOrder(null, null, null, null, null, false, false, (result, orderId) => {
					if(result) {
						this.numpadNumber = 0;

						this.roomsStore.updateRoomStatus(this.roomsStore.activeRoom, () => {
							this.$emit('order-created', orderId);
							this.loadingCta = false;
						});

					}
				});


			}
		}
	}
}
</script>

<style scoped lang="scss">
.numpad-container {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: var(--orders-padding);

	.numpad-container-background {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		padding: 30px 20px;

		@media (max-width: 450px) {
			padding: 30px 12px;
		}

		@media (max-width: 400px) {
			padding: 30px 20px;
		}

		@media (max-width: 320px) {
			box-shadow: none;
			background-color: transparent;
			padding: 0;
		}

		.numpad-screen-container {
			width: 352px;
			margin-bottom: 12px;

			.numpad-screen {
				background-color: var(--color-alpha-4);
				border-radius: 13px;
				box-shadow: inset 0 1px 2px var(--color-alpha-4);
				display: flex;
				align-items: center;
				justify-content: flex-end;
				min-height: 60px;
				font-size: 38px;
				font-weight: 500;
				padding: 4px 12px;
				color: var(--color-bg);
				overflow: hidden;
			}

			@media (max-width: 400px) {
				width: 258px;

				.numpad-screen {
					font-size: 32px;
					min-height: 50px;
				}
			}

		}

		.numpad-actions-container {
			display: flex;
			align-items: stretch;
			justify-content: center;

			.numpad {

				&:deep(.numpad) {

					@media (max-width: 400px) {
						gap: 5px;

						.row {
							gap: 5px;

							.btn {
								width: 60px;
								height: 60px;
								border-radius: 18px;

								.btn-inner {
									border-radius: 15px;
									width: 77%;
									height: 77%;
									font-size: 36px;
								}

								&.action .btn-inner {
									font-size: 32px;
								}
							}
						}
					}
				}

			}
			.numpad-actions {
				margin-left: 12px;


				@media (max-width: 400px) {
					margin-left: 8px;
				}

				.loader-container {
					width: 80px;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;

					@media (max-width: 400px) {
						width: 60px;
						border-radius: 18px;
					}
				}

				.numpad-action-container {
					border-radius: 26px;
					width: 80px;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
					transition: opacity 0.2s ease-in-out;
					background-color: rgb(185, 204, 236);
					color: $primary;

					.numpad-action  {
						border-radius: 20px;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 70%;
						height: 92%;
						transition: box-shadow 0.1s ease-in-out;
						@include noSelect();
						background-color: rgb(185, 204, 236);
						font-size: 36px;
						box-shadow: -3px -3px 6px rgba(255, 255, 255, 0.54), inset 3px 3px 6px rgba(0, 0, 0, 0), 3px 3px 6px rgba(0, 0, 0, 0.18), inset -3px -3px 6px rgba(255, 255, 255, 0);

						&:deep(svg) {
							width: 55%;
							height: 55%;

							.fill {
								fill: var(--color-svg-primary);
							}

							.stroke {
								stroke: var(--color-svg-primary);
							}
						}
					}

					&:active .numpad-action {
						box-shadow: -3px -3px 6px rgba(255, 255, 255, 0), inset 3px 3px 6px rgba(0, 0, 0, 0.18), 3px 3px 6px rgba(0, 0, 0, 0), inset -3px -3px 6px rgba(255, 255, 255, 0.54);
					}

					@media (max-width: 400px) {
						width: 60px;
						border-radius: 18px;

						.numpad-action  {
							width: 77%;
							font-size: 36px;
							border-radius: 15px;

							&:deep(svg) {
								width: 55%;
								height: 55%;
							}
						}
					}


					&.disabled {
						pointer-events: none;
						opacity: 0.5;
					}

				}
			}
		}
	}

}
</style>